export function getCommentVisibility(
  isInternal: boolean | null | undefined,
): 'internal' | 'public' {
  return isInternal ? 'internal' : 'public';
}
